module.exports = {
	"notification.message": "Чтобы вам было удобнее работать на Wix.com, мы используем cookie.",
	"notification.got.it": "Ясно",
	"notification.more.info": "Подробнее"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_ru.json
// module id = 50
// module chunks = 0